module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Le Feu Intérieur")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Sky accepte une mission périlleuse dans l'univers sombre et sensuel de la formation des esclaves du plaisir...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sous la pression croissante de passer à l'étape suivante dans leur relation, la détective Sky Kelley annonce à son fiancé qu'elle préfère attendre. Mais il la quitte brusquement !")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Blessée dans son orgueil et cherchant à s'évader, Sky décide de s'immerger dans une mission audacieuse au cœur de ce monde obscur et sensuel.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lorsque le détective Jim O’Brien découvre que son ex-fiancée s'est engagée dans cette mission risquée, il est furieux. Elle est bien trop inexpérimentée pour un tel danger, et il se sent obligé de la suivre.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mais Jim réalise rapidement que Sky n’est pas une demoiselle en détresse, et elle le lui prouve de manière passionnée, bien au-delà de ses fantasmes"), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("...")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Notes de Licence")]), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Cet ebook est destiné à un usage personnel uniquement.")]), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Veuillez noter que Le Feu Intérieur est une œuvre de fiction.")]), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Les personnages, lieux, décors et événements présentés dans ce livre sont entièrement issus de l'imagination de l'auteur et ne sont en aucun cas basés sur des personnes réelles, vivantes ou décédées, ni sur des événements, lieux ou décors existants.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Le Feu Intérieur")]), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Jan Springer")]), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Sous la pression croissante de passer à l'étape suivante dans leur relation, la détective Sky Kelley annonce à son fiancé qu'elle préfère attendre. Mais il la quitte brusquement !")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Blessée dans son orgueil et cherchant à s'évader, Sky décide de s'immerger dans une mission audacieuse au cœur de ce monde obscur et sensuel.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Lorsque le détective Jim O’Brien découvre que son ex-fiancée s'est engagée dans cette mission risquée, il est furieux. Elle est bien trop inexpérimentée pour un tel danger, et il se sent obligé de la suivre.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Mais Jim réalise rapidement que Sky n’est pas une demoiselle en détresse, et elle le lui prouve de manière passionnée, bien au-delà de ses fantasmes...")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23663476","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 66
// module chunks = 0